import { handleRequestDataForOrganizations } from "../../actions/UserActions/HandleUserActions";
import React from "react";
import { SovosButton } from "mosaic-react";
import { SovosIcon } from "mosaic-react";
import { FileCopy } from "mosaic-react-icons";

const OrganizationalReportButton = (props) => {
    const { i18n, organizationId, pushModal, reload } = props;
    return (
        <SovosButton
            startIcon={
                <SovosIcon>
                    <FileCopy />
                </SovosIcon>
            }
            variant={"text"}
            onClick={() => {
                pushModal({
                    title: "Organization Report",
                    data: {
                        listProps: { ...props, handleRequestDataForOrganizations },
                        organizationId: organizationId,
                        __typename: "OrganizationData",
                    },
                    args: {
                        organizationId: organizationId,
                    },
                    view: "OrganizationDataForm",
                })
                    .then(() => {
                        reload();
                    })
                    .catch(() => null);
            }}
        >
            {i18n`Organization Report`}
        </SovosButton>
    );
};

export default OrganizationalReportButton;
